import update from 'immutability-helper';

import {
    SCAN_TOKEN_REQUEST,
    SCAN_TOKEN_SUCCESS,
    SCAN_TOKEN_ERROR
} from 'actions/scan';

const defaultState = {
    loading: false,
    token: ''
};

function hubs(state = defaultState, action) {
    switch (action.type) {

        case SCAN_TOKEN_REQUEST:
            return update(state, {
                loading: {$set: true}
            });

        case SCAN_TOKEN_SUCCESS:
            //Only set the state if a token has been recognised
            if (action.token != 'null') {
                return update(state, {
                    loading: {$set: false},
                    token: {$set: action.token}
                });
            }
            else {
                return update(state, {
                    loading: {$set: false}
                });
            }

        case SCAN_TOKEN_ERROR:
            return update(state, {
                loading: {$set: false}
            });

        default:
            return state;

    }
}

export default hubs;
